import classNames from "classnames"
import React, { useEffect, useRef } from "react"
import { v4 } from "uuid"
import styles from "./node-with-children.module.scss"
import { useSizing } from "./use-sizing"

interface Props {
  direction: "vertical" | "horizontal"
  spacing?: number | "fill"
  children: (className: string) => React.ReactElement
  alignment: "start" | "center" | "end"
  mainAxisSizing: "fill" | "hug"
  crossAxisSpacing: "fill" | "hug"
}

export function NodeWithChildren(props: Props) {
  const { alignment, children, direction, spacing, mainAxisSizing, crossAxisSpacing } = props

  let spacingValue = spacing
  if (!spacingValue) {
    spacingValue = 0
  }
  const spacingText = spacingValue === "fill" ? "auto" : `${spacingValue}px`

  // YOLOSWAG giant hack. Needed to specify child spacer from parent
  // NOTE: CSS selectors must start with a letter
  const idRef = useRef(`spacing-${v4()}`)

  const sizingClassName = useSizing(mainAxisSizing, crossAxisSpacing)
  const className = classNames(idRef.current, styles.root, sizingClassName, {
    [styles.start]: alignment === "start",
    [styles.center]: alignment === "center",
    [styles.end]: alignment === "end",
    [styles.horizontal]: direction === "horizontal",
    [styles.vertical]: direction === "vertical",
  })

  // YOLOSWAG giant hack adding this during render
  // Not performant FYI; prefer React.createPortal if possible
  const styleTagRef = useRef<HTMLStyleElement>(document.createElement("style"))
  const styleTag = styleTagRef.current
  if (!styleTagRef.current.isConnected) {
    styleTag.innerHTML = `.${idRef.current} > * + * {
      ${direction === "horizontal" ? "margin-left" : "margin-top"}: ${spacingText};
    }`
    document.head.appendChild(styleTag)
  }
  useEffect(() => {
    styleTag.innerHTML = `.${idRef.current} > * + * {
      ${direction === "horizontal" ? "margin-left" : "margin-top"}: ${spacingText};
    }`
    document.head.appendChild(styleTag)
    return () => {
      styleTag.remove()
    }
  }, [direction, spacingText, styleTag])

  return children(className)
}
